import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchHarvestProcess(organization_id, harvest_process_id) {
    return RequesterV1.get(
      `organization/reporting/process/show_reports/${organization_id}/harvest_process/${harvest_process_id}`
    );
  },
  fetchRepByAgroExporters(organization_id, harvest_process_id) {
    return RequesterV1.get(
      `organization/reporting/process/show_reports/${organization_id}/report_by_agro_exporters/${harvest_process_id}`
    );
  },
  fetchRepByProducers(organization_id, harvest_process_id) {
    return RequesterV1.get(
      `organization/reporting/process/show_reports/${organization_id}/report_by_producers/${harvest_process_id}`
    );
  }
};
